import workspaceQuery from 'graphql/queries/salesLedger/SalesOpeningBalanceWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/salesLedger/SalesOpeningBalanceQuery.graphql';
import defaultQuery from 'graphql/queries/salesLedger/SalesOpeningBalanceDefault.graphql';
import mutationQuery from 'graphql/mutations/salesLedger/SalesOpeningBalanceMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/salesLedger/SaveSalesOpeningBalanceTempMutation.graphql';
import fragment from 'graphql/fragments/salesLedger/SalesOpeningBalanceFragment.graphql';

import { formActions } from 'actions/salesLedger/SalesOpeningBalanceAction';

const SalesOpeningBalance = {
  type: 'SalesOpeningBalance',
  title: 'Customer Opening Balances',
  formUrl: '/Customers/OpeningBalance/Details/',
  formTitle: 'Customer Opening Balances',
  workspaceUrl: '/Customers/OpeningBalance/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'SALES_LEDGER_OPENINGBALANCES',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
};

export default SalesOpeningBalance;
